/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import BarChartStatus from '../../../components/Chartjs/BarChartStatus'
import DonaChartStatus from '../../../components/Chartjs/DonutChart'
//import CreateTable from '../../../components/DataTable';
import Reports from '../../../functions/logic/Reports';
import Spiner from '../../../components/Spiner';
import Maintenance from '../../../functions/logic/Maintenance';
import Select2 from '../../../components/Select2';

export default function Status() {
    const param = useParams();
    const [shifts, setShifts] = useState([]);
    const [spiner, setSpiner] = useState(false);
    const [dataKey, setDataKey] = useState(false);
    const [dataChart, setDataChart] = useState([]);
    const [donutChart, setDonutChart] = useState([]);
    const userToken = localStorage.getItem('userToken');
    const [year, setYear] = useState([]);
    const [yearNow, setYearNow] = useState([]);

    useEffect(() => {
        getStatusChart(param);
    }, [param]);

    const getStatusChart = async (param) => {
        setSpiner(true)
        global.MENU_MODULE_SELECT = 'reporteria'
        const actualYear = new Date();
        const response = await Reports.statusDataLogic(userToken, param.moduleId, actualYear.getFullYear());
        const yearsResp = Maintenance.getYears();
        setYear(yearsResp);
        localStorage.setItem('param', JSON.stringify(param.moduleId));
        setDataChart(response[0]);
        setDonutChart(response[1]);
        setDataKey('Utilidad');
        setSpiner(false);
        setYearNow(actualYear.getFullYear());
    }

    const handleClick = async (event) => {
        setSpiner(true)
        const response = await Reports.statusDataDonutLogic(userToken, param.moduleId, event["payload"]["id"], yearNow);
        setShifts(response);
        setSpiner(false);
    }

    const handleOnChange = async (event) => {
        setSpiner(true)
        setYearNow(event.target.value);
        const response = await Reports.statusDataLogic(userToken, param.moduleId, event.target.value);
        setDataChart(response[0]);
        setDonutChart(response[1]);
        setDataKey('Utilidad');
        setSpiner(false)
    }

    return (
        <>
            <Spiner opt={spiner} />
            <div className="content-wrapper">
                <Select2
                    data={year}
                    col={'col-md-2'}
                    header={""}
                    TextInit={"Seleccione un año"}
                    handledOnChange={handleOnChange}
                />
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            Reporte turnos ({yearNow})</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="col-md-12">
                                            <BarChartStatus dataChart={dataChart} dataKey={dataKey} />
                                        </div>
                                    </div>
                                </div >
                            </div >
                        </div >
                    </div >
                </section >

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-5">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            Servicios ({yearNow})</h3>
                                    </div>
                                    <div className="card-body">
                                        <DonaChartStatus donutChart={donutChart} handleClick={handleClick} />
                                    </div>
                                </div >
                            </div >
                            <div className="col-7">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            Trunos por servicios ({yearNow})</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="col-md-12">
                                        </div>
                                    </div>
                                </div >
                            </div >
                        </div >
                    </div >
                </section >
            </div >
        </>
    )

}






